<p-multiSelect
  [filter]="true"
  [ngClass]="{'ng-invalid ng-dirty': shouldShowError }"
  [options]="profiles$ | async"
  [(ngModel)]="selectedProfiles"
  (ngModelChange)="selectedProfilesChanged()"
  optionValue="value"
  selectedItemsLabel="{{'USERS.SELECTED_PROFILES' | translate }}"
  optionLabel="label">
</p-multiSelect>
